<template>
  <div v-loading="loading">
    <el-alert
        :closable="false"
        :type="isValidCustomer ? 'success' : 'warning'"
        style="margin-bottom: 10px">
      Email can be set only to addresses which are registered to a Ring login account (i.e. the account used to login to the mobile app).
    </el-alert>
    <el-alert
        v-if="isValidCustomer && !isPIIAuthorized"
        :closable="false"
        :type="'warning'"
        style="margin-bottom: 10px">
      Customer was found but this account is not authorized to show PII information. Please authorize it on customer's page, <u>you´ll not be able to continue with this request until then.</u>
    </el-alert>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="12">
        <label :style="{ 'color': validEmail ? 'unset' : '#F56C6C' }">
          {{ validEmail ? 'Email' : 'Email: Cannot be blank.' }}
        </label>
        <el-input
            v-model="request_customer.customer_email"
            name="email"
            placeholder="Please input email"
            :disabled="!!request_customer.owner_id"
            :suffix-icon="validEmail ? 'el-icon-check' : 'el-icon-close'"
            @blur="searchCustomer()" />
      </el-col>
      <el-col :span="12">
        <label :style="{ 'color': validPhone ? 'unset' : '#F56C6C' }">
          {{ validPhone ? 'Phone' : 'Phone: Must enter only numeric characters' }}
        </label>
        <el-input
            v-model="request_customer.customer_phone"
            name="phone"
            placeholder="Please input phone number"
            :suffix-icon="validPhone ? 'el-icon-check' : 'el-icon-close'" />
      </el-col>
    </el-row>
    <el-row
        :gutter="20"
        class="form-row">
      <el-col :span="12">
        <label :style="{ 'color': !validFirstName ? '#F56C6C' : 'unset' }">
          {{ validFirstName ? 'First Name' : 'First name: Cannot be blank. Must enter non-numeric characters' }}
        </label>
        <el-input
            v-model="request_customer.firstName"
            name="first_name"
            placeholder="Please input first name"
            :suffix-icon="validFirstName ? 'el-icon-check' : 'el-icon-close'"
            @blur="trimValue('firstName', request_customer.firstName)" />
      </el-col>
      <el-col :span="12">
        <label :style="{ 'color': !validLastName ? '#F56C6C' : 'unset' }">
          {{ validLastName ? 'Last Name' : 'Last name: Cannot be blank. Must enter non-numeric characters' }}
        </label>
        <el-input
            v-model="request_customer.lastName"
            name="last_name"
            placeholder="Please input last name"
            :suffix-icon="validLastName ? 'el-icon-check' : 'el-icon-close'"
            @blur="trimValue('lastName', request_customer.lastName)" />
      </el-col>
    </el-row>

    <CustomerAddress
        ref="address_form"
        v-model="request_address"
        name="address"
        :is-valid.sync="isValidAddress" />
    <div
        style="margin-top: 10px"
        class="center-buttons">
      <el-button
          type="info"
          plain
          @click="reset()">
        Reset
      </el-button>
      <el-button
          :disabled="!isValid || validating || !isPIIAuthorized"
          :loading="validating"
          type="primary"
          plain
          @click="next()">
        Next
      </el-button>
    </div>
    <el-dialog
        title="Validate Address"
        :visible.sync="isOpenAddress"
        append-to-body>
      <el-row
          :span="20"
          class="form-row">
        <el-col :span="12">
          <h4>
            <el-radio
                v-model="selected"
                label="1">
              {{ validatedAddress.state }}
            </el-radio>
          </h4>
          <div v-if="validatedAddress.effective_address">
            <el-row :span="20">
              <el-col :span="8">
                Street
              </el-col>
              <el-col :span="16">
                {{ validatedAddress.effective_address.street_lines }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                City
              </el-col>
              <el-col :span="16">
                {{ validatedAddress.effective_address.city }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                State
              </el-col>
              <el-col :span="16">
                {{ validatedAddress.effective_address.state_or_province_code || validatedAddress.effective_address.city }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                Zip
              </el-col>
              <el-col :span="16">
                {{ validatedAddress.effective_address.postal_code }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                Country
              </el-col>
              <el-col :span="16">
                {{ validatedAddress.effective_address.country_code }}
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="12">
          <h4>
            <el-radio
                v-model="selected"
                label="2">
              CURRENT
            </el-radio>
          </h4>
          <div v-if="request_address">
            <el-row :span="20">
              <el-col :span="8">
                Street
              </el-col>
              <el-col :span="16">
                {{ request_address.customer_address_1 }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                City
              </el-col>
              <el-col :span="16">
                {{ request_address.customer_city }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                State
              </el-col>
              <el-col :span="16">
                {{ request_address.customer_state }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                Zip
              </el-col>
              <el-col :span="16">
                {{ request_address.customer_zip }}
              </el-col>
            </el-row>
            <el-row :span="20">
              <el-col :span="8">
                Country
              </el-col>
              <el-col :span="16">
                {{ request_address.customer_country }}
              </el-col>
            </el-row>
          </div>
        </el-col>
      </el-row>
      <span
          slot="footer"
          class="dialog-footer">
        <el-button @click="isOpenAddress = false">Cancel</el-button>
        <el-button
            type="primary"
            :disabled="!selected"
            @click="confirmAddress">Confirm</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { cloneDeep, isEmpty, get, extend } from "lodash";
import CustomerAddress from "@/components/Shared/CustomerAddress";
import { createNamespacedHelpers as h } from "vuex";

const { mapActions: requestActions, mapGetters: requestGetters } =
  h("db/requests");
const { mapGetters: accountGetters, mapActions: accountActions } =
  h("db/account");

export default {
  name: "CustomerRequestCustomerStep",
  components: {
    CustomerAddress,
  },
  props: {
    device: {
      type: Object,
      required: false,
      default: () => {
        return {};
      },
    },
  },
  data() {
    return {
      valid: false,
      loading: false,
      validating: false,
      isOpenAddress: false,
      verifying: false,
      validatedAddress: {},
      useGooglePlaces: true,
      isValidAddress: false,
      isValidCustomer: true,
      selected: "1",
      customerInfoLoaded: false,
      request_customer: {
        owner_id: null,
        firstName: null,
        lastName: null,
        customer_name: null,
        customer_phone: null,
        customer_email: null,
      },
      request_address: {
        customer_address_1: null,
        customer_address_2: null,
        customer_city: null,
        customer_state: null,
        customer_country: null,
        customer_zip: null,
      },
    };
  },
  computed: {
    ...accountGetters(["customer", "customerId", "piiAuthorized"]),
    ...requestGetters(["requestInProgress"]),
    isPIIAuthorized() {
      let storedEmail = this.requestInProgress.customer.customer_email;
      let email = this.customer.email;
      let obfuscated = /(\*)+/;
      let unauthorized = this.piiAuthorized === false;
      return !(
        obfuscated.test(email) &&
        unauthorized &&
        (obfuscated.test(storedEmail) || isEmpty(storedEmail))
      );
    },
    isValid() {
      return (
        !!this.isValidAddress &&
        this.validEmail &&
        this.validFirstName &&
        this.validLastName &&
        this.validPhone
      );
    },
    validEmail() {
      var empty = isEmpty(this.request_customer.customer_email);
      if (empty) return false;

      return true;
    },
    validFirstName() {
      let firstName = this.request_customer.firstName || "";
      var empty = isEmpty(firstName);
      if (empty) return false;

      let has_numbers = firstName.match(/\d+/);
      return !has_numbers;
    },
    validLastName() {
      let lastName = this.request_customer.lastName || "";
      var empty = isEmpty(lastName);
      if (empty) return false;

      let has_numbers = lastName.match(/\d+/);
      return !has_numbers;
    },
    validPhone() {
      let phone = this.request_customer.customer_phone || "";
      if (phone.match(/^\d+$/)) return true;
      else return false;
    },
  },
  watch: {
    "request_customer.lastName": {
      handler: "parseName",
    },
    "request_customer.firstName": {
      handler: "parseName",
    },
  },
  created() {
    this.parseDataFromStore();
  },
  methods: {
    ...accountActions(["globalSearch"]),
    ...requestActions(["setCustomerInformation", "setAddressInformation"]),
    parseDataFromStore() {
      if (!this.isPIIAuthorized) {
        return;
      }
      if (this.requestInProgress.address.customer_address_1) {
        extend(this.request_address, this.requestInProgress.address);
      }
      if (this.requestInProgress.customer.customer_email) {
        extend(this.request_customer, this.requestInProgress.customer);
      } else if (this.customer) {
        this.request_customer.owner_id = this.customer.id;
        this.request_customer.firstName = this.customer.first_name;
        this.request_customer.lastName = this.customer.last_name;
        this.request_customer.customer_email = this.customer.email;
        this.request_customer.customer_phone = this.customer.phone_number;
      }
    },
    next() {
      this.validating = true;
      axios.post("v2/address/validate", { address: this.request_address }).then(
        (response) => {
          this.validatedAddress = response.data;
          this.validating = false;
          this.isOpenAddress = true;
        },
        (error) => {
          console.log(error);
          this.validating = false;
        }
      );
    },
    back() {
      this.$emit("back");
    },
    reset() {
      this.setCustomerInformation({}).then(() => {
        this.parseDataFromStore();
      });
      this.setAddressInformation({}).then(() => {
        this.$refs.address_form.resetFields();
      });
    },
    confirmAddress() {
      let address = {};
      if (this.selected === "1") {
        const validated = this.validatedAddress.effective_address;
        address.customer_address_1 = validated.street_lines;
        address.customer_address_2 = this.request_address.customer_address_2;
        address.customer_city = validated.city;
        address.customer_state =
          validated.state_or_province_code || validated.city;
        address.customer_zip = validated.postal_code;
        address.customer_country = validated.country_code;
      } else {
        address = cloneDeep(this.request_address);
      }

      address.market = this.validatedAddress.market;
      this.setCustomerInformation(this.request_customer).then((response) => {
        this.setAddressInformation(address).then((response) => {
          this.$emit("next");
        });
      });
    },
    searchCustomer() {
      if (this.request_customer.customer_email == null) return;

      this.globalSearch({
        criteria: this.request_customer.customer_email,
        model: "Customer",
        keep_previous_data: true,
      })
        .then((response) => {
          this.isValidCustomer = response.found;
          if (!this.isValidCustomer) return;

          extend(this.request_customer, this.requestInProgress.customer);
          this.parseDataFromStore();
        })
        .catch((error) => {
          this.isValidCustomer = false;
          console.log(error);
        });
    },
    parseName(new_value, old_value) {
      this.request_customer.customer_name = `${this.request_customer.lastName}, ${this.request_customer.firstName}`;
    },
    trimValue(key, val) {
      this.request_customer[key] = String(val).trim();
    },
  },
};
</script>
